import React, { useEffect, useState } from "react";

function LatestNews() {
  const [newsItems, setNewsItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchNews = async () => {
      try {
        const rssUrl = encodeURIComponent(
          "https://news.google.com/rss/search?q=fraud&hl=en-US&gl=US&ceid=US:en"
        );
        const apiUrl = `https://api.rss2json.com/v1/api.json?rss_url=${rssUrl}`;

        const response = await fetch(apiUrl);
        if (!response.ok) throw new Error("Failed to fetch news");
        const data = await response.json();

        if (data.status === "ok") {
          setNewsItems(data.items);
        } else {
          throw new Error("Error from RSS service");
        }
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchNews();
  }, []);

  if (loading) return <p>Loading news...</p>;
  if (error) return <p>Error loading news: {error}</p>;

  return (
    <div className="latest-news">
      <h2 className="section-title">Latest News on Fraud</h2>
      <ul>
        {newsItems.slice(0, 5).map((item) => (
          <li key={item.guid}>
            <a href={item.link} target="_blank" rel="noopener noreferrer" title={item.title}>
              <span className="date">{new Date(item.pubDate).toLocaleDateString()}</span>
              {item.title}
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
}

export default LatestNews;
